import Vue from 'vue';
import VueRouter from 'vue-router';
import axios from 'axios';
import _ from 'lodash';
import moment from 'moment';
import store from '../store/index';

// Account
import SignUp from '../views/assemble-account/SignUp.vue';
import CompleteProfile from '../views/assemble-account/CompleteProfile.vue';
import Login from '../views/assemble-account/Login.vue';
import Reset from '../views/assemble-account/Reset.vue';
import ResetSubmit from '../views/assemble-account/ResetSubmit.vue';
import Verify from '../views/assemble-account/Verify.vue';

Vue.use(VueRouter);

const loadDashboardComponent = () => import('../views/DashboardWrapper.vue');
const loadFinderComponent = () => import('../views/FinderWrapper.vue');

const accountRoutes = [
  {
    path: '/sign-up',
    name: 'sign-up',
    component: SignUp,
    meta: {
      requiresAuth: false,
    }
  },
  {
    path: '/c/:entityLevel/:entityName/sign-up',
    name: 'custom-sign-up',
    component: SignUp,
    props: (route) => ({
      entityLevel: route.params.entityLevel,
      entityName: route.params.entityName,
    }),
    meta: {
      requiresAuth: false,
    }
  },
  {
    path: '/complete-profile',
    name: 'complete-profile',
    component: CompleteProfile,
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      requiresAuth: false,
    }
  },
  {
    path: '/c/:entityLevel/:entityName/login',
    name: 'custom-login',
    component: Login,
    props: (route) => ({
      entityLevel: route.params.entityLevel,
      entityName: route.params.entityName,
    }),
    meta: {
      requiresAuth: false,
    }
  },
  {
    path: '/c/:entityLevel/:entityName/dashboard',
    name: 'custom-dashboard',
    meta: {
    },
    component: loadDashboardComponent,
    props: (route) => ({
      entityLevel: route.params.entityLevel,
      entityName: route.params.entityName,
    }),

  },
  {
    path: '/c/:entityLevel/:entityName/all-forms',
    name: 'custom-all-forms',
    meta: {
    },
    component: () => import('../views/app/FormsList.vue'),
    props: (route) => ({
      entityLevel: route.params.entityLevel,
      entityName: route.params.entityName,
    }),

  },
  {
    path: '/c/:entityLevel/:entityName/referee',
    name: 'custom-referee',
    meta: {
    },
    component: () => import('../views/app/Referee.vue'),
    props: (route) => ({
      entityLevel: route.params.entityLevel,
      entityName: route.params.entityName,
    }),

  },
  {
    path: '/c/:entityLevel/:entityName/registrations',
    name: 'custom-registrations',
    meta: {
    },
    component: () => import('../views/app/Registrations.vue'),
    props: (route) => ({
      entityLevel: route.params.entityLevel,
      entityName: route.params.entityName,
    }),
  },
  {
    path: '/c/:entityLevel/:entityName/finder',
    name: 'custom-finder',
    meta: {
    },
    component: loadFinderComponent,
    props: (route) => ({
      entityLevel: route.params.entityLevel,
      entityName: route.params.entityName,
      ...route.query,
      ...route.params
    }),
  },
  {
    path: '/reset',
    name: 'reset',
    component: Reset,
    meta: {
      requiresAuth: false,
    }
  },
  {
    path: '/reset/:token',
    name: 'reset.submit',
    component: ResetSubmit,
    meta: {
      requiresAuth: false,
    }
  },
  {
    path: '/verify',
    name: 'verify',
    component: Verify,
  }
];

const routes = [
  {
    path: '/',
    name: 'home',
    meta: {
    },
    component: () => import('../views/app/Home.vue'),
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    meta: {
    },
    component: loadDashboardComponent,
  },
  {
    path: '/all-forms',
    name: 'all-forms',
    meta: {
      requiresAuth: true,
    },
    component: () => import('../views/app/FormsList.vue'),
  },
  {
    path: '/referee',
    name: 'referee',
    meta: {
      requiresAuth: true,
    },
    component: () => import('../views/app/Referee.vue'),
  },
  {
    path: '/registrations',
    name: 'registrations',
    meta: {
      requiresAuth: true,
    },
    component: () => import('../views/app/Registrations.vue'),
  },
  {
    path: '/settings',
    name: 'settings',
    meta: {
      requiresAuth: true,
    },
    component: () => import('../views/app/Settings.vue'),
  },
  // custom settings
  {
    path: '/c/:entityLevel/:entityName/settings',
    name: 'custom-settings',
    meta: {
    },
    component: () => import('../views/app/Settings.vue'),
  },
  {
    path: '/profile/:id',
    name: 'profile',
    meta: {
      requiresAuth: true,
    },
    component: () => import('../views/app/Profile.vue'),
    props: (route) => ({ ...route.query, ...route.params })
  },
  {
    path: '/c/:entityLevel/:entityName/profile/:id',
    name: 'custom-profile',
    meta: {
    },
    component: () => import('../views/app/Profile.vue'),
    props: (route) => ({ ...route.query, ...route.params })
  },
  {
    path: '/forms',
    name: 'forms',
    meta: {
      // displayName: 'Home',
    },
    component: () => import('../views/app/Forms.vue'),
    props: (route) => ({ ...route.query, ...route.params })
  },
  {
    path: '/c/:entityLevel/:entityName/forms',
    name: 'custom-forms',
    meta: {
    },
    component: () => import('../views/app/Forms.vue'),
    props: (route) => ({ ...route.query, ...route.params })
  },
  {
    path: '/store',
    name: 'store',
    meta: {
      // displayName: 'Home',
    },
    component: () => import('../views/app/Store.vue'),
    props: (route) => ({ ...route.query, ...route.params })
  },
  {
    path: '/c/:entityLevel/:entityName/store',
    name: 'custom-store',
    meta: {
    },
    component: () => import('../views/app/Store.vue'),
    props: (route) => ({
      entityLevel: route.params.entityLevel,
      entityName: route.params.entityName,
    }),
  },
  {
    path: '/finder',
    name: 'finder',
    meta: {
      // displayName: 'Home',
    },
    component: loadFinderComponent,
    props: (route) => ({ ...route.query, ...route.params })
  },
  {
    path: '/event/register-individual',
    name: 'event-register-individual',
    meta: {
      // displayName: 'Home',
      requiresAuth: true,
    },
    component: () => import('../views/registration/event/individual/RegisterIndividual.vue'),
    props: true,
  },
  {
    path: '/c/:entityLevel/:entityName/event/register-individual',
    name: 'custom-event-register-individual',
    meta: {
    },
    component: () => import('../views/registration/event/individual/RegisterIndividual.vue'),
    props: (route) => ({ ...route.query, ...route.params })
  },
  {
    path: '/event/register-individual-to-team',
    name: 'event-register-individual-to-team',
    meta: {
      // displayName: 'Home',
      requiresAuth: true,
    },
    component: () => import('../views/registration/event/individual-to-team/RegisterIndividualToTeam.vue'),
    props: true,
  },
  {
    path: '/c/:entityLevel/:entityName/event/register-individual-to-team',
    name: 'custom-event-register-individual-to-team',
    meta: {
    },
    component: () => import('../views/registration/event/individual-to-team/RegisterIndividualToTeam.vue'),
    props: (route) => ({ ...route.query, ...route.params })
  },
  {
    path: '/event/register-team',
    name: 'event-register-team',
    meta: {
      // displayName: 'Home',
    },
    component: () => import('../views/registration/event/team/RegisterTeam.vue'),
    props: true,
  },
  {
    path: '/c/:entityLevel/:entityName/event/register-team',
    name: 'custom-event-register-team',
    meta: {
    },
    component: () => import('../views/registration/event/team/RegisterTeam.vue'),
    props: (route) => ({ ...route.query, ...route.params })
  },
  {
    path: '/entity-registration',
    name: 'entity-registration',
    meta: {
      // displayName: 'Home',
      requiresAuth: true,
    },
    component: () => import('../views/registration/entity/RegisterEntity.vue'),
    props: true,
  },
  {
    path: '/c/:entityLevel/:entityName/entity-registration',
    name: 'custom-entity-registration',
    meta: {
    },
    component: () => import('../views/registration/entity/RegisterEntity.vue'),
    props: (route) => ({ ...route.query, ...route.params })
  },
  {
    path: '/membership/register-individual',
    name: 'membership-register-individual',
    meta: {
      // displayName: 'Home',
      requiresAuth: true,
    },
    component: () => import('../views/registration/membership/individual/RegisterIndividual.vue'),
    props: true,
  },
  {
    path: '/c/:entityLevel/:entityName/membership/register-individual',
    name: 'custom-membership-register-individual',
    meta: {
    },
    component: () => import('../views/registration/membership/individual/RegisterIndividual.vue'),
    props: (route) => ({ ...route.query, ...route.params })
  },
  {
    path: '/membership/register-entity',
    name: 'membership-register-entity',
    meta: {
      // displayName: 'Home',
      requiresAuth: true,
    },
    component: () => import('../views/registration/membership/entity/RegisterEntity.vue'),
    props: true,
  },
  {
    path: '/c/:entityLevel/:entityName/membership/register-entity',
    name: 'custom-membership-register-entity',
    meta: {
    },
    component: () => import('../views/registration/membership/entity/RegisterEntity.vue'),
    props: (route) => ({ ...route.query, ...route.params })
  },
  {
    path: '/documentations',
    name: 'documentations',
    meta: {
      // displayName: 'Home',
      requiresAuth: true,
    },
    component: () => import('../views/app/Documentations.vue'),
    props: true,
  },
  {
    path: '/c/:entityLevel/:entityName/documentations',
    name: 'custom-documentations',
    meta: {
    },
    component: () => import('../views/app/Documentations.vue'),
    props: (route) => ({ ...route.query, ...route.params })
  },
  {
    path: '/payment',
    name: 'payment',
    meta: {
      // displayName: 'Home',
    },
    component: () => import('../views/registration/Payment.vue'),
    props: true
  },
  {
    path: '/c/:entityLevel/:entityName/payment',
    name: 'custom-payment',
    meta: {
    },
    component: () => import('../views/registration/Payment.vue'),
    props: (route) => ({
      entityLevel: route.params.entityLevel,
      entityName: route.params.entityName,
    }),
  },
  {
    path: '/bulk-payment',
    name: 'bulk-payment',
    meta: {
      // displayName: 'Home',
    },
    component: () => import('../views/registration/BulkPayment.vue'),
    props: true
  },
  {
    path: '/c/:entityLevel/:entityName/bulk-payment',
    name: 'custom-bulk-payment',
    meta: {
    },
    component: () => import('../views/registration/BulkPayment.vue'),
    props: (route) => ({
      entityLevel: route.params.entityLevel,
      entityName: route.params.entityName,
    }),
  },
  {
    path: '/success',
    name: 'success',
    meta: {},
    component: () => import('../views/registration/Success.vue'),
    props: (route) => ({ ...route.query, ...route.params })
  },
  {
    path: '/c/:entityLevel/:entityName/success',
    name: 'custom-success',
    meta: {
    },
    component: () => import('../views/registration/Success.vue'),
    props: (route) => ({
      entityLevel: route.params.entityLevel,
      entityName: route.params.entityName,
    }),
  },
  {
    path: '/partial-payment/:id',
    name: 'partial-payment',
    meta: {
      // displayName: 'Home',
    },
    component: () => import('../views/app/components/PartialPayment.vue'),
    props: (route) => ({ ...route.query, ...route.params })
  },
  {
    path: '/partial-payment',
    name: 'partial-payment',
    meta: {
      // displayName: 'Home',
    },
    component: () => import('../views/app/components/PartialPayment.vue'),
    props: true
  },
  // custom partial
  {
    path: '/c/:entityLevel/:entityName/partial-payment',
    name: 'custom-partial-payment',
    meta: {
    },
    component: () => import('../views/app/components/PartialPayment.vue'),
    props: (route) => ({ ...route.query, ...route.params })
  },
  {
    path: '/renew-payment',
    name: 'renew-payment',
    meta: {
      // displayName: 'Home',
    },
    component: () => import('../views/app/components/RenewPayment.vue'),
    props: true
  },
  // custom renew
  {
    path: '/c/:entityLevel/:entityName/renew-payment',
    name: 'custom-renew-payment',
    meta: {
    },
    component: () => import('../views/app/components/RenewPayment.vue'),
    props: (route) => ({ ...route.query, ...route.params })
  },
  {
    path: '*',
    name: 'Error',
    component: () => import('../views/app/Error.vue'),
  },
  ...accountRoutes
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

/* ----- Router Guard ----- */
const httpNoAuth = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
    'national-id': process.env.VUE_APP_NATIONAL_ID
  },
});

router.beforeEach((to, from, next) => {
  if (to.path.includes('c/')) {
    let entityLevel = _.get(to, 'params.entityLevel');
    let entityName = _.get(to, 'params.entityName');
    if (!entityLevel || !entityName) {
      const pathSegments = to.path.split('/');
      const cIndex = pathSegments.indexOf('c');
      if (cIndex !== -1 && pathSegments.length > cIndex + 2) {
        entityLevel = pathSegments[cIndex + 1];
        entityName = pathSegments[cIndex + 2];
      }
    }

    if (!entityLevel || !entityName) {
      console.log('no entity level or entity name!!!');
      store.commit('national/resetCustom', {});
    } else {
      console.log('entity level and entity name!!!');
      const activeEntity = store.getters['national/getEntity'];
      if ((activeEntity && activeEntity.name !== entityName) || !activeEntity._id) {
        store.dispatch('national/getSlugBranding', { entityLevel, entityName });
      }
    }
  }

  if (!to.path.includes('c/')) {
    console.log('resetting custom');

    store.commit('national/resetCustom', {});
  }

  if (to.matched.some((record) => _.get(record, 'meta.requiresAuth') !== false)) {
    const now = moment().valueOf();
    const expiry = store.getters['user/expiry'];
    const userId = store.getters['user/userId'];
    const isAuthenticated = store.getters['user/isAuthenticated'];
    const refreshToken = store.getters['user/refreshToken'];
    const isTempPassword = store.getters['user/isTempPassword'];
    const verified = store.getters['user/isVerified'];
    const goToFinder = store.getters['finder/goToFinder'];
    const params = store.getters['finder/params'];
    const redirectPath = store.state.loginRedirect;

    if (!isAuthenticated && to.path === '/finder') {
      // Save finder query if applicable and user not authenticated
      store.commit('finder/setGoToFinder', true);
      store.commit('finder/setParams', to.query);
    } else if (!isAuthenticated && _.get(to, 'meta.requiresAuth', true) && to.name !== 'dashboard') {
      console.log('setting login redirect');
      store.commit('loginRedirect', to.fullPath);
    }

    // if (to.path !== '/finder' && !to.path.includes('register')) {
    //   console.log('to.path', to.path);
    //   console.log('clearing finder');
    //   store.commit('finder/clearFitlers');
    // }

    console.log('isTempPassword', isTempPassword);
    if (isAuthenticated && expiry - 300 > now) {
      // Valid Token
      if (!verified && to.path !== '/verify') {
        // Account not verified, redirect to verify page
        next('/verify');
      } else if (isTempPassword && to.path !== '/complete-profile') {
        next('/complete-profile');
      } else if (verified && goToFinder) {
        // Account Verified -- Finder Query
        store.commit('finder/clear');
        next({ name: 'finder', params });
      } else if (verified && redirectPath) {
        store.commit('loginRedirect', undefined);
        next(redirectPath);
      } else {
        // Account Verified
        next();
      }
    } else if (expiry - 300 <= now && refreshToken && userId) {
      // Expired Token, refresh token before going to page
      store.commit('loading', { loading: true, text: 'Loading...' });
      httpNoAuth.post('/assemble/api/v1/account/portal/authorize',
        {
          refresh_token: refreshToken,
          user_id: userId,
        })
        .then((response) => {
          // Refresh Successful - Login User
          store.commit('user/login', response.data);
          store.commit('loading', false);
          next();
        })
        .catch(() => {
          // Failed Refresh - Logout User
          store.commit('user/logout');
          store.commit('loading', false);
          router.go('/login');
        });
    } else {
      console.log('no data');
      // get the route params
      const entityLevel = _.get(to, 'params.entityLevel');
      const entityName = _.get(to, 'params.entityName');
      if (!entityLevel || !entityName) {
        store.commit('national/resetCustom', {});
      }
      // No Data - Redirect to Login
      store.commit('user/logout');
      store.commit('loading', false);
      next('/login');
    }
  } else {
    next();
  }
});

export default router;
